<div class="np-window-toaster">
  <ng-container *ngFor="let toaster of toasters">
    <app-toaster [toaster]="toaster" (eventClose)="this.closed($event)"></app-toaster>
  </ng-container>
</div>